'use strict';

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _emojiFlags = require('emoji-flags');

var _emojiFlags2 = _interopRequireDefault(_emojiFlags);

var _themeSections = require('@shopify/theme-sections');

var _utils = require('../helpers/utils');

var _modal = require('../components/modal');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Redirect Modal
 * ------------------------------------------------------------------------------
 * Redirect modal configuration for complete theme support
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections
 *
 * @namespace redirectModal
 */
var selectors = {
  title: '[js-redirect-modal="title"]',
  body: '[js-redirect-modal="body"]',
  redirectLink: '[js-redirect-modal="redirectLink"]'
};

/**
 * Register the `redirect-modal` section type.
 */
(0, _themeSections.register)('redirect-modal', {

  /**
   * Initialise section objects.
   */
  init: function init() {
    var _this = this;

    this.settings = {
      id: 'redirect-modal',
      namespace: 'redirect_modal'
    };

    this.placeholder = {
      countryCode: '%country_code%',
      userCountryStoreUrl: '%user_country_store_url%',
      userCountryCode: '%user_country_code%'
    };

    this.body = document.querySelectorAll(selectors.body);
    this.title = document.querySelector(selectors.title);
    this.redirectLink = document.querySelector(selectors.redirectLink);

    this.modal = new _modal2.default(this.settings.id, {
      onClose: function onClose() {
        return _this.handleCloseEvents();
      }
    });
  },


  /**
   * Callback function when the section is loaded in via the 'sections.load()' function or by Theme Editor
   * 'shopify:section:unload' event
   */
  onLoad: function onLoad() {
    var _this2 = this;

    this.init();
    this.modal.init();

    if (this.isValidGeoIP() && !_jsCookie2.default.get(this.settings.namespace)) {
      this.fetchUserGeolocation().then(function (response) {
        _this2.render(response);
        _this2.setRedirectEvents();

        /**
         * If the user's geolocation country does not match the store's country code
         * and continent code.
         */
        if (!_this2.isMatchedLocation(response)) {
          _this2.modal.show();
          throw new Error('Geolocation could not be found from current session.');
        }

        return response;
      }).catch(function (err) {
        return err;
      });
    }
  },


  /**
   * Callback function when the section is unloaded in the by Theme Editor 'shopify:section:unload' event
   */
  onUnload: function onUnload() {
    this.modal.close(this.settings.id);
  },


  /**
   * Callback function when the section is selected in the by Theme Editor 'shopify:section:select' event.
   */
  onSelect: function onSelect() {
    var _this3 = this;

    this.modal.show(this.settings.id);

    if (this.isValidGeoIP()) {
      this.fetchUserGeolocation().then(function (response) {
        return _this3.render(response);
      }).catch(function (err) {
        return err;
      });
    }
  },


  /**
   * Callback function when the section is deselected in the by Theme Editor 'shopify:section:deselect' event.
   */
  onDeselect: function onDeselect() {
    this.modal.close();
  },


  /**
   * Setting events on redirect link click
   */
  setRedirectEvents: function setRedirectEvents() {
    var _this4 = this;

    (0, _utils.on)('click', document.querySelector(selectors.redirectLink), function (event) {
      return _this4.handleRedirectClick(event);
    });
  },


  /**
   * Handle redirect link click.
   * @param {Event} event - Click event of redirect link.
   */
  handleRedirectClick: function handleRedirectClick(event) {
    event.preventDefault();
    _jsCookie2.default.set(this.settings.namespace, 'dismissed', { expires: 7 });
    window.location = event.currentTarget.href;
  },


  /**
   * Get linked stores from `Frame.Redirects` by geolocation.
   * - Will return only one store.
   * @param {String} location - Location country code.
   */
  getMatchingStore: function getMatchingStore(location) {
    var matchingCountries = Frame.Redirects.filter(function (element) {
      return element.country_code === location.country;
    });

    var matchingContinents = Frame.Redirects.filter(function (element) {
      return element.continent_code === location.continent;
    });

    /**
     * If there is no matching store for the country then fallback
     * to a continent store.
     */
    if (matchingCountries.length <= 0) {
      var foundContinents = matchingContinents.filter(function (element) {
        return !element.country_code;
      });

      if (foundContinents.length <= 0) {
        return matchingContinents[0];
      }
      return foundContinents[0];
    }

    return matchingCountries[0];
  },


  /**
   * Get default store defined in theme settings.
   */
  getDefaultStore: function getDefaultStore() {
    return Frame.Redirects.filter(function (element) {
      if (element.country_code) {
        return element.country_code === theme.store.defaultStore;
      } else {
        return element.continent_code === theme.store.defaultStore;
      }
    })[0];
  },


  /**
   * Replace country code in title and body content.
   * Placeholder options defined in settings.
   * @param {Object} response - GeoIP response from ipstack.
   */
  render: function render(response) {
    var store = this.getMatchingStore(response.location) || this.getDefaultStore();

    if (store.country_code) {
      this.updatePlaceholders(store.country_code, store.store_url, response.location);
      return;
    }
    this.updatePlaceholders(store.continent_code, store.store_url, response.location);
  },


  /**
   * Replace location references in body node.
   * @param {String} iso - The ISO-3166 location to replace the country and flag placeholder.
   * @param {String} url - The store url to replace the store link placeholder.
   * @param {String} location - The location object of the country to replace title.
   */
  updatePlaceholders: function updatePlaceholders(iso, url, location) {
    var _this5 = this;

    this.body.forEach(function (content) {
      content.innerHTML = content.innerHTML.replace(new RegExp(_this5.placeholder.userCountryCode, 'g'), iso);

      content.innerHTML = content.innerHTML.replace(_this5.placeholder.userCountryStoreUrl, url);

      _this5.title.innerHTML = _this5.title.innerHTML.replace(_this5.placeholder.userCountryCode, location.name + ' ' + _emojiFlags2.default.countryCode(location.country).emoji);
    });
  },


  /**
   * Return Geolocation data of current user.
   * @param {payload} - default emitted data from dropdown selector.
   */
  fetchUserGeolocation: function fetchUserGeolocation() {
    var _this6 = this;

    return new Promise(function (resolve, reject) {
      _axios2.default.get('http://api.ipstack.com/check?access_key=' + window.vault.ipstack.accessKey).then(function (response) {
        return resolve(_this6.getUserGeolocation(response.data));
      }).catch(function (err) {
        return reject(err);
      });
    });
  },


  /**
   * Emit user geolocation information from response.
   */
  getUserGeolocation: function getUserGeolocation(response) {
    return {
      location: {
        continent: response.continent_code,
        country: response.country_code,
        name: response.country_name
      },
      currency: {
        code: response.currency.code,
        symbol: response.currency.symbol,
        name: response.currency.name
      }
    };
  },


  /**
   * Check if GeoIP service defined in theme settings.
   */
  isValidGeoIP: function isValidGeoIP() {
    return typeof window.vault.ipstack !== 'undefined' && window.vault.ipstack !== null;
  },


  /**
   * Handle close callback function by setting cookie.
   */
  handleCloseEvents: function handleCloseEvents() {
    _jsCookie2.default.set(this.settings.namespace, 'dismissed', { expires: 7 });
  },


  /**
   * Check if the users geolocation matches the store's location.
   * @param {Object} response - GeoIP response from ipstack.
   */
  isMatchedLocation: function isMatchedLocation(response) {
    return response.location.country === theme.store.countryCode && response.location.continent === theme.store.continentCode;
  }
});